
























































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  MathPart,
  MathPartTypes,
  Problem,
  ProblemSection,
  StudentHistoryRecord,
  StudentSolution,
  SectionedTopic,
  Solution
} from "@/store/types";
import TextEditor from "@/components/TextEditor.vue";
import ExpressionEditor from "@/components/ExpressionEditor.vue";
import ModalDialog from "@/components/ModalDialog.vue";
import StatisticCard from "@/components/StatisticCard.vue";
import store from "@/store/store";
import router from "../router";

const SPACE = "\u00A0\u00A0\u00A0\u00A0\u00A0";



@Component({
  components: { TextEditor, ExpressionEditor, ModalDialog, StatisticCard }
})
export default class SelfTesting extends Vue {
  show = true;
  
  showHelpDialog = false;
  showCongratulationDialog = false;
  showRegretDialog = false;

  mounted() {
    this.show = true;
  }

  get shouldShowHintButton():boolean {
    if (this.solution) {
      return !this.solution.hintRequested;
    }
    return false;
  }
  
  placeCursor(event: Event, index: number) {
    const answersEditors = this.$refs.answers as ExpressionEditor[];
    const ee = answersEditors[index];

    if (event.target && !ee.editor.element.contains(event.target as Node)) {
      ee.editor.activate(true);
    }
  }

  async generate(section: ProblemSection) {
    this.show = false;
    //this._section = section;

    if (
      !store.state.topicState.topics ||
      store.state.topicState.topics.length == 0
    ) {
      await store.dispatch("topicState/loadTopics");
    }

    const topics: SectionedTopic[] = store.getters["topicState/sectionTopics"](
      section
    );

    //TODO: make them not absolutely random

    const index = Math.floor(Math.random() * topics.length);

    const topic = topics[index];

    //TODO: sometoimes solutions have 10+ steps and giant answers
    store.dispatch("problemState/generateProblem", {
      topicId: topic.id,
      section
    });

    return false;
  }

  onKeyInAnswer(e: KeyboardEvent, index: number): boolean {
    if (e.ctrlKey && e.key === "Insert") {
      const answersEditors = this.$refs.answers as ExpressionEditor[];
      const ee = answersEditors[index];

      const solutionEditor = this.$refs.solution as TextEditor;

      const parts = solutionEditor.getMathText();
      let lastMath: MathPart | undefined;
      for (let i = parts.length - 1; i >= 0; i--) {
        if (
          parts[i].t === MathPartTypes.grl ||
          parts[i].t === MathPartTypes.math
        ) {
          lastMath = parts[i];
          break;
        }
      }
      if (lastMath) {
        if (lastMath.t === MathPartTypes.grl) {
          ee.setGRL(lastMath.v);
        } else {
          ee.setInternal(lastMath.v);
        }
      }
      e.preventDefault();

      return false;
    }
    return true;
  }

  async checkAnswer() {
    //проверяет ответ
    //Если ок - помечает задачу как решенную, поздравляет, апдейтит статистику.
    //Если нет, просто запоминает число попыток.
    const answersEditors = this.$refs.answers as ExpressionEditor[];
    const expressions = answersEditors.map(ed => ed.getGRL());
    this.showCongratulationDialog = await store.dispatch(
      "problemState/checkAnswers",
      expressions
    );
    this.showRegretDialog = !this.showCongratulationDialog;
  }

  showHint() {
    this.showHelpDialog = true;
    store.dispatch("problemState/requestHint");
  }

  nextStep() {
    store.dispatch("problemState/nextStep");
  }

  giveUp() {
    store.dispatch("problemState/giveUp");
  }

  get problem(): Problem | undefined {
    return store.state.problemState.problem;
  }

  get problemAndSolution(): MathPart[] | undefined {
    if (!this.solution) {
      return undefined;
    }

    if (this.problem) {
      const ret: MathPart[] = [];
      this.problem.statement.forEach(p => {
        ret.push(p);
      });

      ret.push({ t: MathPartTypes.tag, v: "br" });
      ret.push({ t: MathPartTypes.tag, v: "br" });
      ret.push({ t: MathPartTypes.text, v: "Solution:" });
      ret.push({ t: MathPartTypes.tag, v: "br" });
      ret.push({ t: MathPartTypes.tag, v: "br" });

      const solution = this.problem.solutions[0];

      let index = 1;
      for (
        let stepIndex = 0;
        stepIndex < this.solution.solutionStepsViewed;
        stepIndex++
      ) {
        const step = solution.steps[stepIndex];
        let prefix = "";
        for (let i = 0; i < step.shift; i++) {
          prefix += SPACE;
        }
        ret.push({ t: MathPartTypes.text, v: prefix + index + ")" });

        index++;

        let first = true;
        step.transitions.forEach(t => {
          if (!first) {
            ret.push({ t: MathPartTypes.text, v: " → " });
          }
          ret.push({ t: MathPartTypes.grl, v: t });
          first = false;
        });

        ret.push({ t: MathPartTypes.tag, v: "br" });
        ret.push({ t: MathPartTypes.tag, v: "br" });
      }

      if (this.solution.solved === false) {
        ret.push({ t: MathPartTypes.text, v: "Answer:" });
        ret.push({ t: MathPartTypes.tag, v: "br" });
        let first = true;
        this.problem.answersGrl.forEach(a => {
          if (!first) {
            ret.push({ t: MathPartTypes.tag, v: "br" });
          }
          ret.push({ t: MathPartTypes.grl, v: a });
        });
      }

      return ret;
    }
  }

  get topic(): SectionedTopic | undefined {
    if (this.problem) {
      return store.getters["topicState/problemTopic"](this.problem);
    }
  }

  get solution(): StudentSolution | undefined {
    return store.state.problemState.studentSolution;
  }

  get history(): StudentHistoryRecord[] {
    return store.state.problemState.history;
  }

  get isDerivative(): boolean {
    return this.section == ProblemSection.derivatives;
  }
  get isLimit(): boolean {
    return this.section == ProblemSection.limits;
  }
  get isIntegral(): boolean {
    return this.section == ProblemSection.integrals;
  }

  get section():ProblemSection|undefined {
    if(this.problem) {
      return this.problem.section;
    }
  }

  get solutionStepCount(): number | undefined {
    return store.getters["problemState/solutionsStepsCount"];
  }

  scrollToProduct() {
    const el = document.getElementById("tabs");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}
